import {IDotRezPartialBookingSessionData} from "../../../../dot-rez-api/data-contracts/booking/dot-rez-booking-session-data.interface";
import {BookingMutationActionBase} from "../booking-mutation-action-base";
import {IInsuranceProductModel} from "../../insurance/models/insurance-product.model.interface";
import {BookingModel} from "../../booking.model";
import {IMutationOptions} from "../mutation-options.interface";



export class RemoveInsuranceMutation extends BookingMutationActionBase {

    constructor(private readonly product: IInsuranceProductModel,
                booking: BookingModel,
                options?: IMutationOptions) {
        super(booking, options);
    }


    private _getSsrsToRemove(): string[] {
        let ssrsToRemove: string[] = [];

        for(let passengerSegment of this.booking.getAllFilteredPassengersSegments()) {
            const ssrEditor = passengerSegment.getSsr(this.product.ssrCode);
            ssrEditor.newQuantity = 0;
            ssrsToRemove = [
                ...ssrsToRemove,
                ...ssrEditor.soldSsrs.map(ssr => ssr.ssrKey)
            ]
        }
        
        return ssrsToRemove;
    }

    async _runMutation(): Promise<IDotRezPartialBookingSessionData> {

        for(let passenger of this.booking.passengers) {
            for(let insuranceFee of passenger.fees.filter(f => f.feeCode === this.product.feeCode)) {
                await this.services.airlineWebapi.deleteBookingFee({
                    dotRezToken: this.session.token,
                    feeKey: insuranceFee.feeKey
                });
            }
        }

        await this.booking.session.removeSsrs(this._getSsrsToRemove());

        return await this.booking.session.bookingStateQueryBuilder().useBookingData().getBookingState();

    }

}
